import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/industries/agriculture/page.tsx");
